import * as React from "react";
import type { SVGProps } from "react";
const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8 22a1 1 0 0 1-.71-1.71l8.3-8.29-8.3-8.29a1.004 1.004 0 0 1 1.42-1.42l9 9a1 1 0 0 1 0 1.42l-9 9A1 1 0 0 1 8 22"
    />
  </svg>
);
export default SvgChevronRight;
